export const LinkifyText = ({text}: {text: string | undefined}) => {
  if (!text) return <></>;
  // Expresión regular mejorada para detectar URLs
  const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)|([^\s]+\.[^\s]{2,})/g;

  // Dividimos el texto en partes, manteniendo las URLs
  const parts = text.split(/(https?:\/\/[^\s]+)|(www\.[^\s]+)|([^\s]+\.[^\s]{2,})/g);

  return <> {
    parts.map((part, index) => {
      if (!part) return null; // Ignorar partes vacías del split

      // Verificar si la parte es una URL
      if (part.match(urlRegex)) {
        let url = part;
        // Asegurar que las URLs sin http:// tengan el protocolo
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = `https://${url}`;
        }

        return (
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#228be6',
              textDecoration: 'underline',
              wordBreak: 'break-all',
            }}
          >
            {part}
          </a>
        );
      }

      return <span key={index}>{part}</span>;
    })
    .filter(Boolean)}
  </>
};